<template>
  <v-container v-if="hasTab" fluid class="mb-4">
    <v-row justify="center">
      <v-col>
        <v-card>
          <v-toolbar
              color="primary"
              :dark="$vuetify.theme.dark"
              flat
              dense
              tabs>
            <v-row>
              <v-col cols="12" class="text-left">
                <v-toolbar-title>
                  {{ title }}
                </v-toolbar-title>
              </v-col>
            </v-row>
            <template v-slot:extension>
              <v-tabs
                  :value="hasTab ? current : defaultTab"
                  :mobile-break-point="400"
                  centered
                  :dark="$vuetify.theme.dark"
                  slider-color="textwithbackground"
                  @change="change">
                <v-tab
                    v-for="prop in keys"
                    :key="prop"
                    v-test="{ tab: prop }"
                    :href="`#${prop}`"
                    :class="getTabClass(prop)">
                  {{ $t(tabsEnum[prop]) }}
                </v-tab>
              </v-tabs>
            </template>
          </v-toolbar>
          <!-- для включения поддержки перелистывания на мобильных устройствах убрать touchless и сделать обработку reverse и touch -->
          <v-tabs-items
              v-model="current"
              touchless>
            <v-progress-linear
                v-if="!keys.includes(current)"
                color="loader"
                indeterminate />
            <template v-for="prop in keys">
              <v-tab-item
                  v-if="prop===current"
                  :key="prop"
                  :value="prop"
                  :transition="false"
                  :reverse-transition="false">
                <v-row class="pa-2">
                  <v-col>
                    <slot
                        name="tabItem"
                        :current="prop" />
                  </v-col>
                </v-row>
              </v-tab-item>
            </template>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
  .tab-header  {
    max-width: 280px;
  }
</style>

<script>

  export default {
    props: {
      tabsEnum: {
        type: Object,
        required: true
      },
      value: String,
      defaultTab: String,
      loading: {
        type: Boolean,
        default: false
      },
      fixedTabs: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        current: this.value || this.keys[0]
      }
    },
    computed: {
      keys () {
        return Object.keys(this.tabsEnum)
      },
      hasTab () {
        return !!this.tabsEnum &&
          !!this.tabsEnum[this.value]
      }
    },
    watch: {
      tabsEnum: {
        immediate: true,
        handler (newVal, oldVal) {
          if (newVal) {
            if ((this.fixedTabs && !oldVal) ||
              (!this.fixedTabs && oldVal)) {
              this.replaceRoute()
            }
          }
        }
      },
      loading (newVal, oldVal) {
        if (!newVal &&
          newVal !== oldVal) {
          this.replaceRoute()
        }
      }
    },
    methods: {
      change: function (newValue) {
        this.current = newValue
        this.$emit('input', newValue)
        this.$emit('change', newValue)
      },
      getTabClass: function (tab) {
        const classLength = this.$t(this.tabsEnum[tab]).length > 40 ? 'tab-header' : ''
        const activeClass = tab === this.current ? 'textwithbackground--text' : ''
        return `${classLength} ${activeClass}`.trim()
      },
      replaceRoute: function () {
        if (this.defaultTab &&
          !this.loading &&
          !this.hasTab) {
          this.change(this.defaultTab)
        }
      }
    }
  }
</script>
